import React, { useEffect, useState } from 'react'; 
import { Button, Badge, Modal } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { Divider } from '@mui/material';
import break_box from '../../../../images/product/products.png'; 
const ViewProduct = ({ show, onClose, product }) => {
    const onInit = () => {};
 
    const [productData, setProductData] = useState(null);

    useEffect(() => {
        if (product) {
            setProductData(product);
        }
    }, [product]);

    if (!productData) return <div> </div>;

    const categories = productData.item_category_list?.categories || [];
    const items = productData.item_quantity || [];

    const itemsByCategory = categories.reduce((acc, category) => {
        acc[category.id] = items.filter(item => item.list_id === category.id);
        return acc;
    }, {});

    return (
        <Modal show={show} size="lg" onHide={onClose}>
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Product</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* Header Info */}
                    <div className="row mb-3">
                        <div className="d-flex mb-2 align-items-center justify-content-start gap-3 mt-3">
                            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                <div data-src={productData.product_image || break_box} className='border w-120px h-100px rounded px-1 py-0'>
                                    <img src={productData.product_image || break_box} alt={productData.product_name} className='cursor-pointer w-125px h-100px' />
                                </div>
                            </LightGallery>
                            <div>
                                <label className='text-black font-w500 fs-5'>
                                    <span>{productData.product_name}</span>
                                    <span className='me-1 ms-1'>|</span>
                                    <span>{productData.product_category_name}</span>
                                </label>
                                {/* <div className='d-block'>
                                    <label className="text-black fs-7 font-w40 me-2">
                                        <label className='text-black fs-6 me-2'>Item Category </label>
                                        <Badge bg="success" className='text-white fs-8 py-0 px-1'>
                                            {categories.length}
                                        </Badge>
                                    </label>
                                    <label className='me-1 ms-1 text-black font-w400 fs-5'>|</label>
                                    <label className="text-black fs-7 font-w400 me-2">
                                        <label className='text-black fs-6 me-2'>Item</label>
                                        <Badge bg="info" className='text-white fs-8 py-0 px-1'>
                                            {items.length}
                                        </Badge>
                                    </label> */}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>

                    {/* Times + Description */}
                    <div className='row mb-2'>
                        <div className="col-lg-6">
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Production Start Time</label>
                                    <label className='text-green fs-6 font-w500'>{productData.production_start_time}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Production End Time</label>
                                    <label className='text-danger fs-6 font-w500'>{productData.production_end_time}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Packing Start Time</label>
                                    <label className='text-green fs-6 font-w500'>{productData.packing_start_time}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Packing End Time</label>
                                    <label className='text-danger fs-6 font-w500'>{productData.packing_end_time}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Delivery Start Time</label>
                                    <label className='text-green fs-6 font-w500'>{productData.delivery_start_time}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Delivery End Time</label>
                                    <label className='text-danger fs-6 font-w500'>{productData.delivery_end_time}</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className='row mb-4'>
                                <div className="col-12 text-black fs-6 font-w500">Description</div>
                                <div className="col-12 text-black fs-7">&emsp;&emsp; {productData.description}</div>
                            </div>
                        </div>
                    </div>

                    <Divider />

                    {/* ONE common scroll wrapper for all categories/items */}
                    <div className="row scroll-y mh-400px py-2">
                        <div className="col-12">
                            {categories.map(category => (
                                <div key={category.id} className='mb-4'>
                                    <div className='mb-2 d-flex align-items-center'>
                                        <span className="text-red fs-4 font-w600">{category.item_category_name}</span>
                                        <label className="py-0 px-1 rounded-pill fs-6 border border-info text-black badge bg-none ms-2">{category.count}</label>
                                    </div>
                                    <div className="row">
                                        {(itemsByCategory[category.id] || []).map(item => (
                                            <div className='col-lg-4' key={item.id}>
                                                <div className="card py-0">
                                                    <div className="card-body px-1 py-1">
                                                        <div className="d-flex align-items-center justify-content-start gap-2 mb-1">
                                                            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                <div data-src={item.item_img} className='px-1 py-0'>
                                                                    <img src={item.item_img} alt={item.item_name} className='cursor-pointer w-60px h-60px' />
                                                                </div>
                                                            </LightGallery>
                                                            <div>
                                                                <label className='fs-5 text-green font-w600'>{item.item_name}</label>
                                                                <div className='d-block'>
                                                                    <label className='fs-7 text-info font-w600'>
                                                                        {item.quantity} {item.unit || ''}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {(itemsByCategory[category.id]?.length === 0) && (
                                            <div className="col-12 text-muted">No items found under this category.</div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ViewProduct;
